// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const { abs } = Math;
